import { LeftIcon } from "assets/icons";
import Board from "components/Common/Board/Board";
import MobilePageCover from "components/Common/MobilePageCover/MobilePageCover";
import Button from "components/foundation/Button";
import Modal from "components/foundation/Modal/Modal";
import TagEditForm, {
  TagFormData,
} from "components/foundation/Tag/TagEditForm";
import Toast from "components/foundation/Toast";
import useCompaniesMutation from "features/tag/hooks/mutations/useCompaniesMutation";
import useCompaniesAutoCompleteQuery from "features/tag/hooks/queries/useCompaniesAutoCompleteQuery";
import useCompaniesQuery from "features/tag/hooks/queries/useCompaniesQuery";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

interface TagCreateMobilePageProps {
  disableUnloadTracking: () => void;
}

const TagCreateMobilePage = ({
  disableUnloadTracking,
}: TagCreateMobilePageProps) => {
  const method = useFormContext<TagFormData>();
  const { data: companiesData } = useCompaniesQuery();
  const { data: autoCompleteData } = useCompaniesAutoCompleteQuery({
    searchTerm: method.watch("tag"),
  });
  const { mutate } = useCompaniesMutation();
  const companies = companiesData.data.result;
  const navigate = useNavigate();

  const [isDuplicateTag, setIsDuplicateTag] = useState(false);
  const [isSuccessToast, setIsSuccessToast] = useState(false);
  const [tags, setTags] = useState<string[]>(companies.map((i) => i.name));

  const handleSave = () => {
    // 삭제된 태그를 찾기
    const deletedTags = companies.filter((i) => !tags.includes(i.name));

    // 추가된 태그를 찾기
    const companyNamesSet = new Set(companies.map((i) => i.name));
    const addedTags = tags.filter((tag) => !companyNamesSet.has(tag));

    mutate(
      {
        addCompanies: addedTags.map((i) => ({ name: i })),
        deleteCompanyUuids: deletedTags.map((i) => i.uuid),
      },
      {
        onSuccess: () => {
          setIsSuccessToast(true);
          disableUnloadTracking();
        },
      },
    );
  };

  return (
    <>
      <Toast.Message open={isSuccessToast} onOpenChange={setIsSuccessToast}>
        변경 내용이 저장되었습니다.
      </Toast.Message>

      <Modal.Root open={isDuplicateTag} onOpenChange={setIsDuplicateTag}>
        <Modal.Body
          title="이미 존재하는 법인명입니다."
          onConfirm={() => setIsDuplicateTag(false)}
        />
      </Modal.Root>
      <MobilePageCover header={<LeftIcon onClick={() => navigate(-1)} />}>
        <TagCreatePageContent>
          <h1>법인명 등록 / 삭제</h1>
          <TagEditForm
            tags={tags}
            setTags={setTags}
            placeholder="법인명을 추가하세요"
            autocomplete={autoCompleteData?.data.result.map(
              (i) =>
                ({
                  label: i,
                  value: i,
                }) ?? undefined,
            )}
            onDuplicate={() => {
              setIsDuplicateTag(true);
            }}
          />
          <Modal.Root>
            <Modal.Trigger asChild>
              <Button variant="primary" size="large">
                저장
              </Button>
            </Modal.Trigger>
            <Modal.Body
              title="변경 내용을 저장하시겠습니까?"
              onCancel
              onConfirm={handleSave}
            />
          </Modal.Root>
        </TagCreatePageContent>
      </MobilePageCover>
    </>
  );
};

export default TagCreateMobilePage;

const TagCreatePageContent = styled(Board)`
  padding: 2rem;

  h1 {
    ${({ theme }) => theme.typography.t1.semibold};
    margin-bottom: 2rem;
  }

  > button {
    position: fixed;
    bottom: 0;
    left: 0;

    width: -webkit-fill-available;
    margin: 2rem 1.6rem;
  }
`;
